import React from "react";

export default function NumberField(props) {
  const {
    field: { name, label, required },
    i,
    value,
    handleOnChange,
    errs
  } = props;
  return (
    <div className={`item-${i} form-group`}>
      <label>
        {label}:
        {required ? <span className="required"> *</span> : null}
      </label>
      <input
        type="text"
        name={name}
        id="mostBeNum"
        value={value}
        onChange={handleOnChange}
        className={errs ? "form-control is-invalid" : " form-control"}
      />
      {errs ? <div className="invalid-feedback">{errs}</div> : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/User/UserDetailsForm/renderFields/NumberField.js